<template>
    <div class="modal fade" id="createNewBetto" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
       <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ __('share.Title') }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form action="#" method="POST" @submit.prevent="share">
      <div class="modal-body">
        <p>{{ __('share.Description')}}</p>

        <div class="form-group">
            <label for="data" class="control-label">{{ __('share.Date_Interval') }}</label>
            <div class="row">
                <div class="col-xs-6 col-sm-6">
                    <div class="input-group">
                        <div class="input-group-text">{{ __('share.From') }}:</div>
                        <input type="date" v-model="form.start_date" :class="{ 'is-invalid': form.errors.has('start_date') }" name="start_date" class="form-control" required="" />
                    </div>
                </div>
                <div class="col-xs-6 col-sm-6">
                    <div class="input-group">
                        <div class="input-group-text">{{ __('share.To') }}:</div>
                        <input type="date" v-model="form.end_date" :class="{ 'is-invalid': form.errors.has('end_date') }" name="end_date" class="form-control" required="" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6 col-sm-12" id="result_msg">
                </div>
            </div>
        </div>

      </div>
      <div class="modal-footer">
         <button type="button" data-dismiss="modal" class="btn btn-default">{{ __('share.Close') }}</button>
        <button type="submit" class="btn btn-success"> <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="form.busy" style="display: none"></span>  {{ __('share.Create_a_Link') }}</button>
      </div>
    </form>
    </div>
  </div>
    </div>
</template>

<script>
    import { Form } from 'vform'
    export default {
        data () {
            return {
            form: new Form({
                start_date: '',
                end_date: '',
              })
            }
        },

        methods: {
            share: function() {
                this.submitted = true;
                axios.post('share', this.form)
                    .then( (res) => {
                        var attr = document.getElementById("result_msg");
                        attr.innerHTML = res;
                    })
                    .catch(err => console.log(err));
                this.submitted = false;
            }
        }
    }
</script>
<style>

</style>
